import { PHONE, locationSchema } from "../structured-data-core";

export function getScottsdaleStructuredData() {
  const url = "https://restorehair.com/locations/arizona/scottsdale/";
  const description =
    "Find out about your hair transplant options in Scottsdale with RESTORE Hair. Over 20,000 procedures performed.";
  return [
    locationSchema("Scottsdale", "7150 E Camelback Rd", "Scottsdale", "AZ", PHONE, url, description),
  ];
}
